import { Map as ImmutableMap } from 'immutable';

/*
  Retrieves the list of values except the first
  Usage:
    type tail = Tail<[1,2,3]>; // return [2,3]
*/

/*
 * Extracts the type used to create a ImmutableMapWithTypes
 */

/*
 * Traverse the object map to retrieve the type of specified by the key path
 */

// Preferred over TypedMap
// Allows for type inference on getIn calls
/* ------------------- Avoid when possible ---------------------- */
// Note: using TypedMap is discouraged because TypeScript poorly infers the type `<K extends keyof T>`
// Prefer ImmutableMapWithTypes instead
// A type that can wrap a TypeScript interface and provide hinting
// for an immutable Map of the same structure
// A utility function to build an immutable Map of a given structure,
// ensuring that initial keys and values conform to the given type
export const buildTypedMap = data => ImmutableMap(data);